/**
 * HTML que el editor de bloques no puede round-trip (tablas, FAQ, widgets…).
 * Guardar esos posts vía bloques destruye enlaces, tablas y secciones.
 */
const RICH_RE =
    /<(table|thead|tbody|tr|td|th|section|details|summary|figure|figcaption|iframe|video|aside|dl|dt|dd|h[4-6]|a)\b/i;

export function isRichBlogHtml(html: string | null | undefined): boolean {
    const s = String(html || '');
    if (!s.trim()) return false;
    if (RICH_RE.test(s)) return true;
    if (/data-blog-widget/i.test(s)) return true;
    return false;
}
